// Discard expected 404 errors (unknown routes, missing listings) so they
// don't reach Bugsnag — brute-force URL probing was flooding the error logs.
export default defineNuxtPlugin((nuxtApp) => {
  const bugsnag = nuxtApp.$bugsnag;
  if (!bugsnag?.addOnError) return;

  bugsnag.addOnError((event) => {
    if (event.originalError?.statusCode === 404) {
      return false;
    }
  });
});
